import { createFileRoute } from '@tanstack/react-router';
import { Package } from 'lucide-react';

import { ListEmptyState } from '../../../components/ListEmptyState.js';
import { assertUuidRouteParams } from '../../../lib/assert-uuid-route-params.js';

export const Route = createFileRoute('/receiving/transfer/$transferOrderId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: ReceivingTransferOrderPlaceholder,
});

// eslint-disable-next-line react-refresh/only-export-components -- the route's component is private to this file
function ReceivingTransferOrderPlaceholder() {
  return (
    <ListEmptyState
      icon={<Package />}
      title="Transfer receiving is coming soon."
      description="Receive purchase orders from the receiving desk for now."
    />
  );
}
